import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {paramsFetchData} from '../../lib/redux/actions/params';
import {wsConnect} from '../../lib/redux/actions/socket';
import {BaseApp, Econom, Electro, Energo, Hydro, Main, Menu, Teplo} from '../';
import {Redirect} from "react-router";


class App extends BaseApp {

    render() {
        let loadingNode = <div className="loading"/>;
        let loading = this.props.isLoading ? loadingNode : null;
        return (
            <Router history="">
                <div className="container App" id={this.props.appScreen}>
                    {loading}
                    <Redirect from="/" to="/app/main"/>
                    <Menu menuItems={[
                        {name: "main", caption: "Главная"},
                        {name: "hydro", caption: "Гидравлическая", fault: this.props.hydroFault},
                        {name: "teplo", caption: "Тепловая", fault: this.props.teploFault},
                        {name: "electro", caption: "Электрическая", fault: this.props.electroFault},
                        {name: "econom", caption: "Экономическая"},
                        {name: "energo", caption: "Энергетическая"}
                    ]}
                    />
                    <Route exact={false} path="/app/main" render={({match}) => (
                        <Main {...this.props}/>
                    )}/>
                    <Route exact={true} path="/app/hydro" render={({match}) => (
                        <Hydro {...this.props}/>
                    )}/>
                    <Route exact={true} path="/app/teplo" render={({match}) => (
                        <Teplo {...this.props}/>
                    )}/>
                    <Route exact={true} path="/app/electro" render={({match}) => (
                        <Electro {...this.props}/>
                    )}/>
                    <Route exact={true} path="/app/econom" render={({match}) => (
                        <Econom {...this.props}/>
                    )}/>
                    <Route exact={true} path="/app/energo" render={({match}) => (
                        <Energo {...this.props}/>
                    )}/>
                </div>
            </Router>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        psVal: state.params,
        hasErrored: state.paramsHasErrored,
        isLoading: state.paramsAreLoading,
        hydroFault: state.params['tc_8_128_1'],
        teploFault: state.params['tc_8_128_2'],
        electroFault: state.params['tc_8_128_3'],
        appScreen: state.appScreen
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (url) => dispatch(paramsFetchData(url)),
        wsConnect: () => dispatch(wsConnect())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/components/App/index.jsx